import {
  hidePresentationEditor,
  TogglePresentationEditorPayload,
  togglePresentationEditor,
} from './actions';
import { persistentReducedStream, reducer } from '@ardoq/rxbeach';
import { closePresentation } from 'presentation/presentations2024/actions';

type State = boolean;

const togglePresentationEditorReducer = (
  _: State,
  { shouldShow }: TogglePresentationEditorPayload
) => shouldShow;
const handleTogglePresentationEditor = reducer(
  togglePresentationEditor,
  togglePresentationEditorReducer
);
const closePresentationReducer = (): State => false;
const handleHidePresentationEditor = reducer(
  hidePresentationEditor,
  closePresentationReducer
);
const handleClosePresentation = reducer(
  closePresentation,
  closePresentationReducer
);

const togglePresentationEditor$ = persistentReducedStream(
  'togglePresentationEditor$',
  false,
  [
    handleTogglePresentationEditor,
    handleClosePresentation,
    handleHidePresentationEditor,
  ]
);

export { togglePresentationEditor$ };
